import styled from 'styled-components';
import { Link, NavLink } from 'react-router-dom';
import { Button as ReactButton } from '@material/react-button';
import { NAVBAR_HEIGHT } from 'src/utils/constants';
import { MD_BREAK_POINT } from 'src/utils/constants';

export const Button = styled(ReactButton)`
  min-width: 88px;
  text-transform: none;
  .mdc-button__label {
    color: var(--color-ink-dark);
  }
  @media (max-width: ${MD_BREAK_POINT}) {
    display: none;
  }
`;

export const TabBar = styled.div`
  width: 100%;

  @media (max-width: ${MD_BREAK_POINT}) {
    display: none;
  }
`;

export const Tab = styled(NavLink)`
  font-size: 18px;
  font-weight: 500;
  max-width: 200px;
  text-align: center;
  margin: 20px;
  color: var(--color-ink-notasdark);
  text-decoration: none;

  &.active {
    color: var(--color-primary);
  }
`;

export const ButtonLink = styled(ReactButton)`
  text-transform: none;
  min-width: 100px;
  margin-right: 20px;
  @media (min-width: ${MD_BREAK_POINT}) {
    min-width: 140px;
    margin-right: 14px;
  }
`;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CenteredContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

export const ImgLogo = styled.img`
  width: 106px;
`;

export const CenteredLink = styled(Link)`
  margin: 6px 24px 0 0;
`;

export const Container = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  box-sizing: border-box;
  height: ${NAVBAR_HEIGHT}px;
  background-color: var(--color-background-surface);
  border-bottom: 1px solid var(--color-support-lines);
  padding: 0 16px;
  .mdc-tab-bar {
    padding-top: 4px;
  }
  .mdc-tab {
    max-width: max-content;
    padding: 0 20px;
    margin: 0;
  }
  .mdc-tab__content {
    font-size: 18px;
    font-weight: 500;
  }
  .mdc-tab--active .mdc-tab__content {
    color: var(--color-primary);
  }
  .mdc-tab-indicator {
    display: none;
  }
`;

export const StyledBurger = styled.div`
  cursor: pointer;
  margin-top: 4px;
  @media (min-width: ${MD_BREAK_POINT}) {
    display: none;
  }
`;

export const BurgerLine = styled.span<{ isOpen: boolean }>`
  display: block;
  width: 20px;
  height: 2px;
  margin-bottom: 5px;
  position: relative;
  background: black;
  border-radius: 3px;
  z-index: 1;
  transform-origin: 4px 0px;
  transition: transform 0.3s cubic-bezier(0.5, 0.2, 0.05, 1),
    background 0.3s cubic-bezier(0.5, 0.2, 0.05, 1), opacity 0.3s ease;
  ${({ isOpen }) =>
    isOpen &&
    `
        opacity: 1;
        transform: rotate(-45deg) translate(0, -1px) scale(1.38, 1);
    `}
  }
  :first-child {
    transform-origin: 0% 0%;
    ${({ isOpen }) =>
      isOpen &&
      'transform: rotate(45deg) translate(-1px, -2px) scale(1.38, 1);'}
  }
  :nth-last-child(2) {
    transform-origin: 0% 100%;
    ${({ isOpen }) =>
      isOpen &&
      `
        opacity: 0;
        transform: rotate(0deg) scale(0.2, 0.2);
      `}
  }
`;

export const MenuItem = styled(NavLink)`
  font-size: 18px;
  height: 40px;
  width: 100%;
  cursor: pointer;
  margin-left: 40px;
  margin-bottom: 8px;
  text-decoration: none;
  color: var(--color-ink-notasdark);
  :hover,
  :active {
    color: var(--color-brand-tend);
  }
`;

export const MenuContainer = styled.div<{ isOpen?: boolean }>`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--color-background-app);
  width: 100vw;
  height: calc(100vh - 64px);
  top: 64px;
  right: 0;
  padding-top: 32px;
  overflow: hidden;
  transition: 0.2s cubic-bezier(0.5, 0.2, 0.05, 1);
  transform-origin: 100% 0;
  transform: scale(${({ isOpen }) => (isOpen ? '1, 1' : '0, 1')});
`;

export const Divider = styled.span`
  border: 1px solid var(--color-support-lines);
  width: 100%;
  margin-bottom: 24px;
`;
